{
  "id": "antarctica",
  "name": "Antarctica",
  "viewBox": {
    "x": 11.2,
    "y": 13.41,
    "width": 977.6,
    "height": 815.98
  },
  "backdropColor": {
    "light": "#dfe3e1",
    "dark": "#262c2e",
    "topBar": true
  },
  "gameLayout": {},
  "selectionInnerGlow": true,
  "edgeConfig": {
    "internalBorderWidth": 2.4,
    "regionBorderWidth": 11.5,
    "bridgeStrokeWidth": 0
  },
  "regionToggleCorner": "bottom-left",
  "regions": [
    {
      "id": "peninsula",
      "name": "Antarctic Peninsula",
      "bonus": 3,
      "shape": "M 37.6 199.0 L 40.6 206.9 L 46.6 212.8 L 47.4 221.0 L 48.4 229.2 L 51.2 230.3 L 54.1 230.9 L 56.6 232.7 L 58.0 235.4 L 57.6 237.8 L 58.5 240.2 L 57.5 242.4 L 56.2 244.4 L 57.9 242.9 L 60.1 243.0 L 62.0 241.9 L 63.1 240.1 L 70.0 243.5 L 77.3 246.1 L 84.7 248.3 L 91.5 252.0 L 92.0 256.5 L 93.3 260.8 L 95.7 264.6 L 98.2 268.3 L 111.6 270.4 L 121.2 279.9 L 134.1 278.4 L 141.9 278.3 L 141.9 278.3 L 141.9 278.3 L 147.0 278.2 L 150.5 283.1 L 155.5 286.5 L 156.0 287.5 L 158.1 292.0 L 162.9 295.8 L 163.1 309.3 L 157.5 321.7 L 156.8 331.8 L 156.8 331.8 L 156.8 331.8 L 156.8 331.8 L 156.6 335.7 L 164.4 347.3 L 159.5 349.6 L 155.5 353.4 L 151.1 356.4 L 147.3 360.3 L 151.0 364.3 L 153.8 368.8 L 158.1 372.3 L 160.6 377.2 L 160.9 390.6 L 153.2 401.7 L 147.9 411.1 L 268.2 417.4 L 319.3 396.4 L 323.8 384.4 L 317.4 382.9 L 309.5 384.8 L 302.3 381.5 L 294.3 380.8 L 291.8 382.9 L 288.7 383.7 L 283.47 392.01 L 282.99 391.81 L 285.5 380.1 L 284.6 377.4 L 281.6 375.9 L 278.4 375.0 L 275.8 377.1 L 273.2 379.3 L 274.2 382.2 L 274.5 385.2 L 276.3 387.8 L 276.9 390.8 L 271.4 392.8 L 266.0 395.3 L 261.4 399.0 L 256.1 401.6 L 252.3 401.4 L 248.4 401.6 L 249.1 398.9 L 248.4 396.1 L 251.8 393.1 L 253.6 389.0 L 257.5 387.0 L 261.7 385.5 L 261.7 383.4 L 261.3 381.3 L 261.5 379.1 L 261.7 377.0 L 256.9 379.3 L 252.8 382.8 L 249.5 387.5 L 243.8 388.4 L 242.1 387.2 L 240.3 386.2 L 236.73 384.22 L 240.6 378.9 L 243.6 372.8 L 246.0 366.4 L 250.3 361.0 L 248.8 357.7 L 248.1 354.2 L 245.1 355.6 L 242.9 358.2 L 240.9 360.8 L 239.0 363.4 L 233.6 364.6 L 228.2 365.3 L 222.6 365.9 L 217.7 368.6 L 214.3 367.6 L 210.8 366.6 L 205.84 362.52 L 213.4 359.5 L 216.6 355.8 L 221.2 353.9 L 223.1 349.5 L 223.9 344.9 L 225.9 340.6 L 228.0 336.4 L 226.2 334.7 L 224.1 333.4 L 221.9 332.2 L 219.8 330.9 L 219.3 322.0 L 219.8 313.0 L 219.6 306.2 L 219.6 306.2 L 219.6 306.2 L 219.54 304.17 L 217.4 295.3 L 214.3 292.7 L 211.4 290.0 L 207.4 288.8 L 204.5 285.9 L 204.5 283.0 L 203.5 280.2 L 204.1 277.4 L 204.5 274.5 L 201.1 272.1 L 197.1 270.6 L 195.1 268.2 L 194.5 267.4 L 191.7 264.3 L 189.0 264.6 L 186.6 263.2 L 182.08 265.08 L 182.3 260.0 L 181.7 257.7 L 181.6 255.4 L 179.2 258.5 L 176.7 261.4 L 173.6 263.9 L 169.7 264.9 L 168.4 261.7 L 168.2 258.2 L 168.4 254.7 L 167.9 251.3 L 165.4 251.3 L 162.9 251.7 L 160.5 252.4 L 158.4 253.7 L 156.8 250.4 L 156.6 246.78 L 156.4 246.7 L 156.4 246.7 L 147.1 243.0 L 138.3 237.7 L 128.4 234.9 L 118.5 232.6 L 112.5 232.7 L 106.5 232.9 L 100.6 231.4 L 94.6 232.1 L 94.1 234.2 L 92.9 235.9 L 91.8 237.7 L 91.3 239.7 L 84.4 237.4 L 77.2 236.3 L 70.4 233.9 L 63.4 232.1 L 60.5 225.3 L 56.6 219.2 L 51.4 213.8 L 48.6 206.9 L 48.9 203.6 L 51.8 202.0 L 53.1 199.3 L 54.1 196.6 L 50.3 193.2 L 47.7 188.8 L 43.3 186.2 L 39.8 182.5 L 40.2 174.1 L 43.7 166.5 L 44.0 158.2 L 46.8 150.3 L 44.2 146.2 L 43.2 141.4 L 40.1 137.8 L 37.3 133.9 L 38.1 148.0 L 35.9 162.0 L 36.9 176.1 L 35.6 190.1 L 33.9 191.6 L 32.0 192.7 L 31.4 194.8 L 30.0 196.6 L 33.8 197.7 L 37.6 199.0 Z",
      "territoryIds": [
        "esperanza",
        "rothera",
        "larsen-shelf",
        "marguerite-bay"
      ],
      "bonusAnchor": {
        "x": 222.01,
        "y": 306.86
      },
      "color": "#8D6E63"
    },
    {
      "id": "spire",
      "name": "Palmer Spire",
      "bonus": 1,
      "territoryIds": [
        "palmer-spire"
      ],
      "shape": "M 344.5 233.8 L 345.4 237.0 L 347.0 239.2 L 349.2 240.8 L 350.7 243.1 L 353.0 244.6 L 358.4 241.7 L 363.5 238.1 L 369.6 238.8 L 375.8 238.3 L 378.1 241.5 L 379.8 245.0 L 382.9 247.8 L 383.8 251.8 L 380.6 262.6 L 379.2 273.8 L 373.1 283.5 L 370.5 294.6 L 371.6 300.5 L 373.2 306.2 L 373.2 312.2 L 374.3 318.1 L 371.0 317.9 L 367.7 317.7 L 364.4 318.9 L 361.0 318.1 L 360.6 320.5 L 359.7 322.8 L 359.6 325.3 L 358.6 327.6 L 357.4 338.2 L 357.5 338.6 L 430.7 266.0 L 423.9 224.6 L 368.1 156.6 L 359.6 172.8 L 352.9 184.7 L 351.8 198.3 L 350.4 211.7 L 345.0 224.1 L 345.2 227.3 L 345.1 230.6 L 344.5 233.8 Z",
      "color": "#1A237E"
    },
    {
      "id": "queen-maud",
      "name": "Queen Maud Land",
      "bonus": 5,
      "shape": "M 396.96 96.61 L 394.5 97.3 L 389.5 101.7 L 389.8 104.0 L 389.3 106.3 L 389.6 108.6 L 389.5 110.9 L 393.5 111.1 L 397.4 112.0 L 401.3 111.1 L 405.01 109.09 L 404.8 114.5 L 388.4 125.2 L 371.7 135.5 L 368.9 155.2 L 368.1 156.6 L 423.9 224.6 L 430.7 266.0 L 510.1 283.1 L 583.9 248.7 L 635.7 257.1 L 668.3 226.1 L 701.8 75.7 L 699.2 74.5 L 693.5 73.5 L 679.5 71.5 L 665.5 70.1 L 651.5 67.6 L 644.6 64.9 L 638.3 62.4 L 630.8 57.1 L 623.4 51.6 L 617.1 44.8 L 610.3 38.6 L 605.1 38.5 L 600.3 40.4 L 595.3 41.8 L 590.1 41.1 L 587.7 39.0 L 584.5 38.6 L 581.9 37.0 L 579.3 35.5 L 574.3 37.9 L 568.9 37.5 L 564.3 40.2 L 559.6 42.7 L 557.4 39.3 L 553.8 37.4 L 552.0 34.0 L 550.1 30.6 L 546.0 30.7 L 541.9 30.2 L 537.8 29.1 L 533.6 30.0 L 526.3 33.9 L 519.3 38.4 L 511.2 37.1 L 502.91 36.5 L 502.3 36.9 L 497.3 40.2 L 494.5 46.3 L 488.2 48.2 L 482.9 52.2 L 478.2 51.1 L 473.8 49.1 L 469.1 47.9 L 464.3 47.0 L 459.8 48.3 L 455.1 48.6 L 450.3 48.4 L 445.9 50.4 L 443.3 49.2 L 440.6 48.4 L 440.5 46.0 L 440.3 43.6 L 440.3 41.2 L 440.9 38.9 L 437.5 43.3 L 435.7 48.5 L 434.8 54.0 L 432.3 58.9 L 429.2 59.6 L 426.0 60.1 L 425.0 56.7 L 423.5 53.5 L 421.4 50.6 L 418.6 48.4 L 411.8 60.1 L 401.8 69.1 L 398.4 82.4 L 401.0 95.83 L 397.7 96.4 L 397.19 96.54 L 396.96 96.61 Z",
      "territoryIds": [
        "halley-station",
        "vahsel-bay",
        "astrid-coast",
        "schirmacher-oasis",
        "muhlig-hofmann",
        "riiser-larsen"
      ],
      "bonusAnchor": {
        "x": 553.22,
        "y": 130.84
      },
      "color": "#B8F000"
    },
    {
      "id": "enderby",
      "name": "Enderby–Mawson",
      "bonus": 4,
      "shape": "M 837.6 114.5 L 837.8 116.7 L 836.5 118.5 L 836.2 120.5 L 835.5 122.5 L 833.4 123.2 L 831.2 123.4 L 829.0 123.3 L 826.9 122.5 L 826.9 118.6 L 826.6 114.7 L 825.1 110.9 L 821.7 108.6 L 806.7 105.8 L 791.5 104.3 L 777.5 97.8 L 762.2 95.6 L 755.5 96.3 L 749.1 98.2 L 744.3 102.9 L 739.6 107.6 L 738.9 103.5 L 736.7 99.9 L 733.6 97.1 L 730.1 95.0 L 728.5 87.0 L 729.4 78.9 L 728.4 70.9 L 727.2 62.9 L 724.0 65.0 L 720.8 67.1 L 717.7 69.4 L 714.9 72.0 L 708.9 72.7 L 704.5 76.9 L 701.8 75.7 L 668.3 226.1 L 635.7 257.1 L 666.2 395.0 L 667.3 396.5 L 700.7 401.4 L 773.4 385.1 L 838.9 424.3 L 955.7 413.6 L 955.8 413.5 L 956.4 409.8 L 955.0 399.5 L 953.6 389.3 L 945.7 382.3 L 940.6 373.1 L 941.5 370.3 L 942.5 367.6 L 942.2 364.6 L 943.1 361.8 L 940.4 360.8 L 937.5 360.9 L 934.7 360.3 L 932.0 359.6 L 930.2 355.0 L 927.4 351.0 L 924.9 346.7 L 921.8 342.9 L 916.7 341.0 L 911.8 338.6 L 906.5 338.0 L 901.1 337.1 L 895.2 333.9 L 888.9 331.6 L 884.5 326.7 L 879.8 321.9 L 876.0 319.1 L 875.2 314.4 L 874.7 310.0 L 872.8 306.0 L 863.3 304.8 L 853.7 303.8 L 844.2 306.0 L 839.3 305.6 L 834.5 305.2 L 832.8 303.1 L 829.45 297.84 L 835.9 297.3 L 840.7 298.2 L 845.5 297.2 L 848.8 291.5 L 852.8 286.3 L 852.2 279.3 L 856.1 273.5 L 866.7 275.5 L 868.74 275.02 L 877.2 273.0 L 887.8 273.3 L 898.3 271.6 L 899.6 269.9 L 901.6 269.2 L 903.2 267.9 L 904.6 266.4 L 901.3 261.2 L 898.6 255.6 L 895.3 250.3 L 891.0 245.8 L 891.5 239.4 L 894.6 233.8 L 894.2 227.4 L 891.6 221.6 L 889.5 212.7 L 884.5 205.0 L 878.3 198.2 L 875.2 189.5 L 876.7 182.8 L 878.1 176.0 L 875.5 169.4 L 875.6 162.4 L 878.0 162.6 L 880.4 162.6 L 882.8 162.7 L 885.2 162.4 L 886.7 157.9 L 887.0 153.2 L 887.8 143.8 L 885.6 139.5 L 882.5 135.7 L 880.3 131.4 L 876.7 128.0 L 871.8 125.4 L 866.4 124.0 L 862.4 119.8 L 856.7 118.7 L 853.7 121.8 L 850.6 124.8 L 847.3 127.6 L 843.8 130.1 L 842.4 126.1 L 841.2 122.1 L 839.5 118.2 L 838.2 115.7 L 837.6 114.5 Z",
      "territoryIds": [
        "mawson-station",
        "macrobertson-land",
        "amery-shelf",
        "lambert-pass",
        "cape-ann"
      ],
      "bonusAnchor": {
        "x": 764.78,
        "y": 251.08
      },
      "color": "#00D4E8"
    },
    {
      "id": "wilkes",
      "name": "Wilkes Land",
      "bonus": 5,
      "shape": "M 934.2 567.2 L 934.2 567.2 L 934.2 567.2 L 935.3 559.9 L 940.5 551.6 L 946.8 544.1 L 951.3 543.4 L 955.5 541.4 L 959.1 538.3 L 963.8 537.8 L 966.0 532.2 L 966.9 526.2 L 963.2 521.6 L 959.5 516.8 L 962.0 514.5 L 964.6 512.5 L 967.1 510.1 L 970.0 508.4 L 968.3 506.9 L 966.3 505.8 L 964.0 505.3 L 962.0 504.2 L 960.0 500.3 L 959.1 496.1 L 958.9 491.8 L 957.6 487.6 L 959.4 476.3 L 958.3 465.0 L 959.0 453.7 L 960.2 442.4 L 957.9 438.1 L 957.1 433.2 L 955.1 428.8 L 954.0 424.1 L 954.2 420.4 L 954.0 416.7 L 955.7 413.6 L 838.9 424.3 L 773.4 385.1 L 700.7 401.4 L 667.3 396.5 L 608.1 518.8 L 610.9 528.1 L 641.6 566.9 L 653.6 622.2 L 681.2 667.7 L 682.1 685.9 L 728.0 798.5 L 730.3 798.7 L 737.5 797.6 L 744.7 798.2 L 747.1 801.1 L 749.2 804.2 L 768.0 795.2 L 787.8 788.9 L 806.5 779.8 L 825.7 772.0 L 833.9 765.0 L 840.6 756.5 L 845.5 746.8 L 853.1 739.0 L 853.3 734.4 L 851.4 730.2 L 849.3 726.2 L 847.6 722.0 L 849.4 719.5 L 850.4 716.6 L 851.6 713.8 L 853.2 711.2 L 859.0 709.4 L 865.1 709.3 L 871.2 710.8 L 877.0 708.1 L 882.3 694.3 L 884.1 679.6 L 885.3 671.6 L 886.3 665.1 L 890.9 651.1 L 895.5 648.2 L 899.7 644.9 L 904.1 641.6 L 907.2 637.1 L 909.1 638.5 L 911.4 638.4 L 913.5 637.7 L 915.6 637.1 L 916.8 633.8 L 919.6 631.6 L 919.8 628.2 L 920.9 624.9 L 925.7 622.2 L 931.3 621.5 L 936.6 620.1 L 941.3 617.3 L 941.3 606.9 L 940.0 596.5 L 936.7 586.4 L 929.5 578.5 L 933.8 569.6 L 934.2 567.2 Z",
      "territoryIds": [
        "casey-station",
        "vostok-hollow",
        "concordia-plateau",
        "dome-c",
        "knox-coast",
        "aurora-caldera"
      ],
      "bonusAnchor": {
        "x": 786.86,
        "y": 553.97
      },
      "color": "#4A148C"
    },
    {
      "id": "ross",
      "name": "Victoria–Ross",
      "bonus": 5,
      "shape": "M 381.1 602.4 L 381.1 602.4 L 385.7 600.4 L 389.8 597.3 L 393.1 593.4 L 393.0 590.7 L 393.9 588.2 L 394.0 585.6 L 394.3 583.0 L 398.1 583.3 L 401.9 583.1 L 405.5 584.1 L 408.7 586.3 L 408.6 582.5 L 408.6 578.8 L 407.4 575.2 L 406.4 571.6 L 409.4 567.8 L 411.3 563.3 L 414.7 559.5 L 415.3 554.5 L 417.7 553.3 L 420.3 552.9 L 422.9 554.2 L 425.6 553.3 L 427.1 555.7 L 428.7 558.0 L 430.9 559.9 L 433.4 561.2 L 433.2 558.0 L 433.1 554.8 L 434.4 551.6 L 433.4 548.3 L 437.2 546.9 L 441.1 545.6 L 445.2 545.5 L 449.2 546.1 L 448.7 543.0 L 447.9 539.9 L 446.2 537.2 L 444.4 534.6 L 446.5 531.6 L 449.1 529.0 L 443.9 526.1 L 439.0 523.0 L 434.2 519.3 L 430.8 514.4 L 431.6 511.0 L 433.3 508.0 L 436.0 508.3 L 438.7 508.7 L 441.4 508.4 L 444.1 508.0 L 453.84 511.66 L 454.8 512.2 L 454.8 512.2 L 454.8 512.2 L 463.6 517.1 L 465.5 528.4 L 474.4 535.7 L 481.7 539.9 L 489.5 543.0 L 495.7 549.4 L 504.5 550.7 L 516.2 560.5 L 522.6 574.5 L 530.3 588.0 L 539.2 592.6 L 539.2 592.6 L 539.2 592.6 L 544.2 595.1 L 546.9 601.5 L 551.8 606.3 L 554.0 612.7 L 555.1 619.4 L 556.8 623.0 L 557.9 626.7 L 557.7 630.7 L 557.7 634.6 L 555.5 640.0 L 552.9 645.2 L 547.7 647.9 L 543.7 652.3 L 544.0 653.3 L 544.0 653.3 L 546.1 660.2 L 550.5 667.2 L 557.1 672.0 L 563.4 677.2 L 561.9 687.8 L 566.6 697.4 L 571.58 705.67 L 572.9 707.9 L 572.9 707.9 L 577.1 715.0 L 574.4 716.9 L 572.0 719.3 L 569.8 721.7 L 568.1 724.6 L 565.1 733.8 L 564.4 743.5 L 559.8 752.0 L 555.5 760.6 L 552.9 762.1 L 550.7 764.1 L 548.7 766.4 L 546.0 767.8 L 548.5 773.0 L 545.6 778.0 L 544.6 783.0 L 545.0 788.1 L 550.1 792.7 L 555.5 797.0 L 562.4 798.4 L 568.2 802.4 L 579.6 799.7 L 591.1 802.2 L 602.5 799.7 L 614.0 801.5 L 621.9 802.3 L 629.9 801.8 L 634.3 808.5 L 640.4 813.7 L 646.0 812.4 L 651.6 811.0 L 657.5 810.8 L 662.7 808.0 L 665.5 809.4 L 668.2 810.8 L 671.1 811.8 L 674.2 812.2 L 677.6 808.0 L 682.3 805.5 L 686.1 801.7 L 691.2 799.9 L 693.5 800.8 L 695.6 802.2 L 697.7 803.5 L 700.0 804.6 L 703.7 801.8 L 708.1 800.6 L 711.6 797.5 L 716.1 796.4 L 723.1 798.2 L 728.0 798.5 L 682.1 685.9 L 681.2 667.7 L 653.6 622.2 L 641.6 566.9 L 610.9 528.1 L 608.1 518.8 L 490.1 483.4 L 453.8 504.7 L 375.9 491.9 L 337.6 559.5 L 340.1 580.6 L 309.5 651.3 L 321.8 655.4 L 325.1 648.9 L 329.4 642.9 L 335.4 638.8 L 340.4 633.4 L 344.5 634.3 L 348.7 634.1 L 352.7 635.3 L 356.9 635.1 L 361.6 639.8 L 366.2 644.7 L 369.7 650.3 L 373.1 656.1 L 376.3 656.5 L 379.2 658.1 L 382.4 657.4 L 385.3 656.1 L 385.5 653.2 L 385.7 650.2 L 386.6 647.4 L 387.6 644.6 L 385.1 644.1 L 382.7 643.2 L 380.3 642.2 L 378.1 641.0 L 379.1 636.2 L 379.8 631.4 L 383.8 622.4 L 381.2 618.0 L 378.0 614.1 L 376.2 609.2 L 376.3 604.0 L 381.1 602.4 L 381.1 602.4 Z",
      "territoryIds": [
        "mcmurdo-sound",
        "ross-ice-shelf",
        "mount-erebus",
        "cape-adare",
        "beardmore-glacier",
        "roosevelt-isle"
      ],
      "bonusAnchor": {
        "x": 469.74,
        "y": 587.78
      },
      "color": "#E0E0E0"
    },
    {
      "id": "marie-byrd",
      "name": "Marie Byrd Land",
      "bonus": 4,
      "shape": "M 142.2 426.5 L 143.8 428.1 L 145.3 429.9 L 149.9 449.0 L 150.6 468.6 L 147.6 487.9 L 147.3 507.5 L 150.7 505.8 L 152.9 502.8 L 153.9 497.8 L 155.3 492.9 L 155.4 487.8 L 154.3 482.8 L 156.9 482.0 L 159.5 482.8 L 161.1 485.9 L 162.4 489.2 L 163.6 492.5 L 164.3 495.9 L 165.9 491.2 L 167.7 486.6 L 170.3 482.3 L 172.1 477.6 L 175.5 478.1 L 178.6 479.5 L 181.2 481.6 L 183.3 484.3 L 185.1 482.7 L 187.1 481.4 L 193.8 478.78 L 189.6 485.7 L 189.6 489.0 L 189.2 492.3 L 192.3 497.8 L 196.6 502.3 L 197.7 508.5 L 200.7 514.1 L 200.3 518.2 L 200.9 522.4 L 200.6 525.8 L 200.5 526.5 L 200.51 526.65 L 200.51 526.78 L 200.51 526.78 L 200.7 530.6 L 197.5 533.1 L 193.8 534.6 L 190.6 531.9 L 186.4 531.7 L 185.9 535.0 L 185.2 538.2 L 187.9 538.0 L 190.5 538.4 L 193.2 538.2 L 195.8 537.4 L 196.0 541.0 L 197.2 544.4 L 194.8 546.4 L 193.7 549.3 L 191.8 551.8 L 189.4 553.7 L 191.5 553.7 L 193.6 554.0 L 195.7 554.5 L 197.7 555.3 L 197.4 559.5 L 199.2 563.2 L 202.03 566.23 L 202.4 569.0 L 202.4 569.0 L 202.6 570.5 L 213.2 590.4 L 229.3 606.1 L 243.45 615.53 L 244.6 616.3 L 248.1 618.6 L 261.7 636.6 L 262.1 638.6 L 262.1 640.6 L 261.6 642.6 L 261.7 644.6 L 277.1 645.7 L 291.5 651.2 L 307.1 650.5 L 309.5 651.3 L 340.1 580.6 L 337.6 559.5 L 375.9 491.9 L 319.3 396.4 L 268.2 417.4 L 147.9 411.1 L 147.0 412.9 L 139.1 423.0 L 140.2 425.1 L 142.2 426.5 Z",
      "territoryIds": [
        "thwaites-glacier",
        "pine-island",
        "amundsen-coast",
        "sidley-crest",
        "executive-range"
      ],
      "bonusAnchor": {
        "x": 248.8,
        "y": 511.35
      },
      "color": "#F48FB1"
    },
    {
      "id": "polar-plateau",
      "name": "Polar Plateau",
      "bonus": 6,
      "shape": "M 357.5 338.6 L 358.7 342.3 L 360.7 348.4 L 368.0 356.1 L 372.5 365.6 L 361.2 367.4 L 349.9 365.7 L 338.4 364.8 L 332.3 361.4 L 325.9 378.6 L 329.5 380.4 L 327.5 382.6 L 325.3 384.7 L 323.8 384.4 L 319.3 396.4 L 375.9 491.9 L 453.8 504.7 L 490.1 483.4 L 608.1 518.8 L 667.3 396.5 L 666.2 395.0 L 635.7 257.1 L 583.9 248.7 L 510.1 283.1 L 430.7 266.0 L 357.5 338.6 Z",
      "territoryIds": [
        "amundsen-scott",
        "pole-of-inaccessibility",
        "vinson-massif",
        "argus-dome"
      ],
      "bonusAnchor": {
        "x": 528.98,
        "y": 374.1
      },
      "color": "#7A0000"
    }
  ],
  "territories": [
    {
      "id": "esperanza",
      "name": "Esperanza",
      "regionId": "peninsula",
      "adjacencies": [
        "rothera"
      ],
      "shape": "M 30 196.6 L 31.4 194.8 L 32 192.7 L 33.9 191.6 L 35.6 190.1 L 36.9 176.1 L 35.9 162 L 38.1 148 L 37.3 133.9 L 40.1 137.8 L 43.2 141.4 L 44.2 146.2 L 46.8 150.3 L 44 158.2 L 43.7 166.5 L 40.2 174.1 L 39.8 182.5 L 43.3 186.2 L 47.7 188.8 L 50.3 193.2 L 54.1 196.6 L 53.1 199.3 L 51.8 202 L 48.9 203.6 L 48.6 206.9 L 51.4 213.8 L 56.6 219.2 L 60.5 225.3 L 63.4 232.1 L 70.4 233.9 L 77.2 236.3 L 84.4 237.4 L 91.3 239.7 L 91.8 237.7 L 92.9 235.9 L 94.1 234.2 L 94.6 232.1 L 100.6 231.4 L 106.5 232.9 L 112.5 232.7 L 118.5 232.6 L 128.4 234.9 L 138.3 237.7 L 147.1 243 L 156.4 246.7 L 141.9 278.3 L 134.1 278.4 L 121.2 279.9 L 111.6 270.4 L 98.2 268.3 L 95.7 264.6 L 93.3 260.8 L 92 256.5 L 91.5 252 L 84.7 248.3 L 77.3 246.1 L 70 243.5 L 63.1 240.1 L 62 241.9 L 60.1 243 L 57.9 242.9 L 56.2 244.4 L 57.5 242.4 L 58.5 240.2 L 57.6 237.8 L 58 235.4 L 56.6 232.7 L 54.1 230.9 L 51.2 230.3 L 48.4 229.2 L 47.4 221 L 46.6 212.8 L 40.6 206.9 L 37.6 199 L 33.8 197.7 Z",
      "position": {
        "x": 116.59,
        "y": 251.88
      },
      "badgeAnchor": {
        "x": 116.59,
        "y": 251.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rothera",
      "name": "Rothera",
      "regionId": "peninsula",
      "adjacencies": [
        "esperanza",
        "larsen-shelf"
      ],
      "shape": "M 141.9 278.3 L 156.4 246.7 L 156.6 246.8 L 156.8 250.4 L 158.4 253.7 L 160.5 252.4 L 162.9 251.7 L 165.4 251.3 L 167.9 251.3 L 168.4 254.7 L 168.2 258.2 L 168.4 261.7 L 169.7 264.9 L 173.6 263.9 L 176.7 261.4 L 179.2 258.5 L 181.6 255.4 L 181.7 257.7 L 182.3 260 L 182.2 262.3 L 181.6 264.5 L 184.2 264.2 L 186.6 263.2 L 189 264.6 L 191.7 264.3 L 194.5 267.4 L 195.1 268.2 L 156 287.5 L 155.5 286.5 L 150.5 283.1 L 147 278.2 Z",
      "position": {
        "x": 164.5,
        "y": 269.1
      },
      "badgeAnchor": {
        "x": 159.36,
        "y": 271.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "larsen-shelf",
      "name": "Larsen Shelf",
      "regionId": "peninsula",
      "adjacencies": [
        "marguerite-bay",
        "rothera"
      ],
      "shape": "M 156 287.5 L 195.1 268.2 L 197.1 270.6 L 201.1 272.1 L 204.5 274.5 L 204.1 277.4 L 203.5 280.2 L 204.5 283 L 204.5 285.9 L 207.4 288.8 L 211.4 290 L 214.3 292.7 L 217.4 295.3 L 219.5 304 L 219.6 306.2 L 156.8 331.8 L 157.5 321.7 L 163.1 309.3 L 162.9 295.8 L 158.1 292 Z",
      "position": {
        "x": 185.3,
        "y": 299
      },
      "badgeAnchor": {
        "x": 184.82,
        "y": 297.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "palmer-spire",
      "name": "Palmer Spire",
      "regionId": "spire",
      "adjacencies": [
        "amundsen-scott",
        "muhlig-hofmann",
        "schirmacher-oasis"
      ],
      "shape": "M 344.5 233.8 L 345.4 237.0 L 347.0 239.2 L 349.2 240.8 L 350.7 243.1 L 353.0 244.6 L 358.4 241.7 L 363.5 238.1 L 369.6 238.8 L 375.8 238.3 L 378.1 241.5 L 379.8 245.0 L 382.9 247.8 L 383.8 251.8 L 380.6 262.6 L 379.2 273.8 L 373.1 283.5 L 370.5 294.6 L 371.6 300.5 L 373.2 306.2 L 373.2 312.2 L 374.3 318.1 L 371.0 317.9 L 367.7 317.7 L 364.4 318.9 L 361.0 318.1 L 360.6 320.5 L 359.7 322.8 L 359.6 325.3 L 358.6 327.6 L 357.4 338.2 L 357.5 338.6 L 430.7 266.0 L 423.9 224.6 L 368.1 156.6 L 359.6 172.8 L 352.9 184.7 L 351.8 198.3 L 350.4 211.7 L 345.0 224.1 L 345.2 227.3 L 345.1 230.6 L 344.5 233.8 Z",
      "position": {
        "x": 386.9,
        "y": 237.7
      },
      "badgeAnchor": {
        "x": 378.17,
        "y": 210.63
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "marguerite-bay",
      "name": "Marguerite Bay",
      "regionId": "peninsula",
      "adjacencies": [
        "larsen-shelf",
        "pine-island",
        "thwaites-glacier",
        "vinson-massif"
      ],
      "shape": "M 147.3 360.3 L 151.1 356.4 L 155.5 353.4 L 159.5 349.6 L 164.4 347.3 L 156.6 335.7 L 156.8 331.8 L 219.6 306.2 L 219.8 313 L 219.3 322 L 219.8 330.9 L 221.9 332.2 L 224.1 333.4 L 226.2 334.7 L 228 336.4 L 225.9 340.6 L 223.9 344.9 L 223.1 349.5 L 221.2 353.9 L 216.6 355.8 L 213.4 359.5 L 208.9 361.3 L 204.5 363.4 L 208 364.3 L 210.8 366.6 L 214.3 367.6 L 217.7 368.6 L 222.6 365.9 L 228.2 365.3 L 233.6 364.6 L 239 363.4 L 240.9 360.8 L 242.9 358.2 L 245.1 355.6 L 248.1 354.2 L 248.8 357.7 L 250.3 361 L 246 366.4 L 243.6 372.8 L 240.6 378.9 L 236.6 384.4 L 238.5 385.2 L 240.3 386.2 L 242.1 387.2 L 243.8 388.4 L 249.5 387.5 L 252.8 382.8 L 256.9 379.3 L 261.7 377 L 261.5 379.1 L 261.3 381.3 L 261.7 383.4 L 261.7 385.5 L 257.5 387 L 253.6 389 L 251.8 393.1 L 248.4 396.1 L 249.1 398.9 L 248.4 401.6 L 252.3 401.4 L 256.1 401.6 L 261.4 399 L 266 395.3 L 271.4 392.8 L 276.9 390.8 L 276.3 387.8 L 274.5 385.2 L 274.2 382.2 L 273.2 379.3 L 275.8 377.1 L 278.4 375 L 281.6 375.9 L 284.6 377.4 L 285.5 380.1 L 284.9 382.9 L 284.7 385.6 L 284.6 388.4 L 287 386.4 L 288.7 383.7 L 291.8 382.9 L 294.3 380.8 L 302.3 381.5 L 309.5 384.8 L 317.4 382.9 L 323.8 384.4 L 319.3 396.4 L 268.2 417.4 L 147.9 411.1 L 153.2 401.7 L 160.9 390.6 L 160.6 377.2 L 158.1 372.3 L 153.8 368.8 L 151 364.3 Z",
      "position": {
        "x": 190.76,
        "y": 378.55
      },
      "badgeAnchor": {
        "x": 187.22,
        "y": 370.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halley-station",
      "name": "Halley Station",
      "regionId": "queen-maud",
      "adjacencies": [
        "astrid-coast",
        "schirmacher-oasis",
        "vahsel-bay"
      ],
      "shape": "M 398.4 82.4 L 401.8 69.1 L 411.8 60.1 L 418.6 48.4 L 421.4 50.6 L 423.5 53.5 L 425 56.7 L 426 60.1 L 429.2 59.6 L 432.3 58.9 L 434.8 54 L 435.7 48.5 L 437.5 43.3 L 440.9 38.9 L 440.3 41.2 L 440.3 43.6 L 440.5 46 L 440.6 48.4 L 443.3 49.2 L 445.9 50.4 L 450.3 48.4 L 455.1 48.6 L 459.8 48.3 L 464.3 47 L 469.1 47.9 L 473.8 49.1 L 478.2 51.1 L 482.9 52.2 L 488.2 48.2 L 494.5 46.3 L 497.3 40.2 L 502.3 36.9 L 508.5 102.7 L 476.8 132.6 L 400 96 L 401 95.8 Z",
      "position": {
        "x": 458.5,
        "y": 84
      },
      "badgeAnchor": {
        "x": 465.49,
        "y": 84.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vahsel-bay",
      "name": "Vahsel Bay",
      "regionId": "queen-maud",
      "adjacencies": [
        "astrid-coast",
        "halley-station",
        "muhlig-hofmann",
        "riiser-larsen",
        "schirmacher-oasis"
      ],
      "shape": "M 476.8 132.6 L 508.5 102.7 L 555.7 131.4 L 549.1 183.6 L 480.3 167.2 Z",
      "position": {
        "x": 516.9,
        "y": 145.2
      },
      "badgeAnchor": {
        "x": 512.55,
        "y": 141.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "astrid-coast",
      "name": "Astrid Coast",
      "regionId": "queen-maud",
      "adjacencies": [
        "halley-station",
        "riiser-larsen",
        "vahsel-bay"
      ],
      "shape": "M 502.3 36.9 L 502.9 36.5 L 511.2 37.1 L 519.3 38.4 L 526.3 33.9 L 533.6 30 L 537.8 29.1 L 541.9 30.2 L 546 30.7 L 550.1 30.6 L 552 34 L 553.8 37.4 L 557.4 39.3 L 559.6 42.7 L 564.3 40.2 L 568.9 37.5 L 574.3 37.9 L 579.3 35.5 L 581.9 37 L 584.5 38.6 L 587.7 39 L 590.1 41.1 L 595.3 41.8 L 600.3 40.4 L 605.1 38.5 L 610.3 38.6 L 617.1 44.8 L 623.4 51.6 L 630.8 57.1 L 638.3 62.4 L 644.6 64.9 L 555.7 131.4 L 508.5 102.7 Z",
      "position": {
        "x": 561.8,
        "y": 74.5
      },
      "badgeAnchor": {
        "x": 553.44,
        "y": 84.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "schirmacher-oasis",
      "name": "Schirmacher Oasis",
      "regionId": "queen-maud",
      "adjacencies": [
        "halley-station",
        "muhlig-hofmann",
        "palmer-spire",
        "vahsel-bay"
      ],
      "shape": "M 368.1 156.6 L 368.9 155.2 L 371.7 135.5 L 388.4 125.2 L 404.8 114.5 L 404.9 111.9 L 404.8 109.2 L 401.3 111.1 L 397.4 112 L 393.5 111.1 L 389.5 110.9 L 389.6 108.6 L 389.3 106.3 L 389.8 104 L 389.5 101.7 L 392 99.5 L 394.5 97.3 L 397.7 96.4 L 400 96 L 476.8 132.6 L 480.3 167.2 L 423.9 224.6 Z",
      "position": {
        "x": 424.7,
        "y": 156.8
      },
      "badgeAnchor": {
        "x": 425.95,
        "y": 158.29
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "muhlig-hofmann",
      "name": "Muhlig-Hofmann",
      "regionId": "queen-maud",
      "adjacencies": [
        "amundsen-scott",
        "palmer-spire",
        "pole-of-inaccessibility",
        "riiser-larsen",
        "schirmacher-oasis",
        "vahsel-bay"
      ],
      "shape": "M 423.9 224.6 L 480.3 167.2 L 549.1 183.6 L 583.9 248.7 L 510.1 283.1 L 430.7 266 Z",
      "position": {
        "x": 500.3,
        "y": 228.3
      },
      "badgeAnchor": {
        "x": 501.4,
        "y": 226.96
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "riiser-larsen",
      "name": "Riiser-Larsen",
      "regionId": "queen-maud",
      "adjacencies": [
        "amery-shelf",
        "astrid-coast",
        "mawson-station",
        "muhlig-hofmann",
        "pole-of-inaccessibility",
        "vahsel-bay"
      ],
      "shape": "M 549.1 183.6 L 555.7 131.4 L 644.6 64.9 L 651.5 67.6 L 665.5 70.1 L 679.5 71.5 L 693.5 73.5 L 699.2 74.5 L 701.8 75.7 L 668.3 226.1 L 635.7 257.1 L 583.9 248.7 Z",
      "position": {
        "x": 625.4,
        "y": 160.6
      },
      "badgeAnchor": {
        "x": 618.29,
        "y": 164
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mawson-station",
      "name": "Mawson Station",
      "regionId": "enderby",
      "adjacencies": [
        "amery-shelf",
        "lambert-pass",
        "macrobertson-land",
        "riiser-larsen"
      ],
      "shape": "M 668.3 226.1 L 701.8 75.7 L 704.5 76.9 L 708.9 72.7 L 714.9 72 L 717.7 69.4 L 720.8 67.1 L 724 65 L 727.2 62.9 L 728.4 70.9 L 729.4 78.9 L 728.5 87 L 730.1 95 L 733.6 97.1 L 736.7 99.9 L 738.9 103.5 L 739.6 107.6 L 744.3 102.9 L 749.1 98.2 L 755.5 96.3 L 762.2 95.6 L 777.5 97.8 L 791.5 104.3 L 806.7 105.8 L 821.7 108.6 L 825.1 110.9 L 826.6 114.7 L 826.9 118.6 L 826.9 122.5 L 829 123.3 L 831.2 123.4 L 833.4 123.2 L 835.5 122.5 L 836.2 120.5 L 836.5 118.5 L 837.8 116.7 L 837.6 114.5 L 838.2 115.7 L 796.6 229.8 L 757.1 248.9 Z",
      "position": {
        "x": 747.7,
        "y": 165.3
      },
      "badgeAnchor": {
        "x": 745.29,
        "y": 176.24
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "macrobertson-land",
      "name": "MacRobertson Land",
      "regionId": "enderby",
      "adjacencies": [
        "lambert-pass",
        "mawson-station"
      ],
      "shape": "M 796.6 229.8 L 838.2 115.7 L 839.5 118.2 L 841.2 122.1 L 842.4 126.1 L 843.8 130.1 L 847.3 127.6 L 850.6 124.8 L 853.7 121.8 L 856.7 118.7 L 862.4 119.8 L 866.4 124 L 871.8 125.4 L 876.7 128 L 880.3 131.4 L 882.5 135.7 L 885.6 139.5 L 887.8 143.8 L 887.4 148.5 L 887 153.2 L 886.7 157.9 L 885.2 162.4 L 882.8 162.7 L 880.4 162.6 L 878 162.6 L 875.6 162.4 L 875.5 169.4 L 878.1 176 L 876.7 182.8 L 875.2 189.5 L 878.3 198.2 L 884.5 205 L 889.5 212.7 L 891.6 221.6 L 894.2 227.4 L 894.6 233.8 L 891.5 239.4 L 891 245.8 L 895.3 250.3 L 898.6 255.6 L 901.3 261.2 L 904.6 266.4 L 903.2 267.9 L 901.6 269.2 L 899.6 269.9 L 898.3 271.6 L 887.8 273.3 L 877.2 273 L 868.8 275 Z",
      "position": {
        "x": 852.2,
        "y": 201.4
      },
      "badgeAnchor": {
        "x": 845.19,
        "y": 210.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "amery-shelf",
      "name": "Amery Shelf",
      "regionId": "enderby",
      "adjacencies": [
        "argus-dome",
        "cape-ann",
        "casey-station",
        "lambert-pass",
        "mawson-station",
        "pole-of-inaccessibility",
        "riiser-larsen",
        "vostok-hollow"
      ],
      "shape": "M 635.7 257.1 L 668.3 226.1 L 757.1 248.9 L 790.6 337.3 L 773.4 385.1 L 700.7 401.4 L 667.3 396.5 L 666.2 395 Z",
      "position": {
        "x": 711.2,
        "y": 315.7
      },
      "badgeAnchor": {
        "x": 715.57,
        "y": 321.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lambert-pass",
      "name": "Lambert Pass",
      "regionId": "enderby",
      "adjacencies": [
        "amery-shelf",
        "cape-ann",
        "macrobertson-land",
        "mawson-station"
      ],
      "shape": "M 757.1 248.9 L 796.6 229.8 L 868.8 275 L 866.7 275.5 L 856.1 273.5 L 852.2 279.3 L 852.8 286.3 L 848.8 291.5 L 845.5 297.2 L 840.7 298.2 L 835.9 297.3 L 831.1 297.7 L 826.4 299 L 828.6 300.7 L 831.4 300.9 L 832.8 303.1 L 834.5 305.2 L 839.3 305.6 L 790.6 337.3 Z",
      "position": {
        "x": 805.4,
        "y": 278.6
      },
      "badgeAnchor": {
        "x": 798.55,
        "y": 274.62
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cape-ann",
      "name": "Cape Ann",
      "regionId": "enderby",
      "adjacencies": [
        "amery-shelf",
        "concordia-plateau",
        "lambert-pass",
        "vostok-hollow"
      ],
      "shape": "M 773.4 385.1 L 790.6 337.3 L 839.3 305.6 L 844.2 306 L 853.7 303.8 L 863.3 304.8 L 872.8 306 L 874.7 310 L 875.2 314.4 L 876 319.1 L 879.8 321.9 L 884.5 326.7 L 888.9 331.6 L 895.2 333.9 L 901.1 337.1 L 906.5 338 L 911.8 338.6 L 916.7 341 L 921.8 342.9 L 924.9 346.7 L 927.4 351 L 930.2 355 L 932 359.6 L 934.7 360.3 L 937.5 360.9 L 940.4 360.8 L 943.1 361.8 L 942.2 364.6 L 942.5 367.6 L 941.5 370.3 L 940.6 373.1 L 945.7 382.3 L 953.6 389.3 L 955 399.5 L 956.4 409.8 L 955.8 413.5 L 955.7 413.6 L 838.9 424.3 Z",
      "position": {
        "x": 862.6,
        "y": 370.7
      },
      "badgeAnchor": {
        "x": 844.88,
        "y": 365.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "casey-station",
      "name": "Casey Station",
      "regionId": "wilkes",
      "adjacencies": [
        "amery-shelf",
        "argus-dome",
        "cape-adare",
        "dome-c",
        "mount-erebus",
        "vostok-hollow"
      ],
      "shape": "M 608.1 518.8 L 667.3 396.5 L 700.7 401.4 L 761.4 530.9 L 641.6 566.9 L 610.9 528.1 Z",
      "position": {
        "x": 680.7,
        "y": 490.2
      },
      "badgeAnchor": {
        "x": 682.35,
        "y": 495.01
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vostok-hollow",
      "name": "Vostok Hollow",
      "regionId": "wilkes",
      "adjacencies": [
        "amery-shelf",
        "aurora-caldera",
        "cape-ann",
        "casey-station",
        "concordia-plateau",
        "dome-c"
      ],
      "shape": "M 700.7 401.4 L 773.4 385.1 L 838.9 424.3 L 810.9 523.2 L 783.3 540 L 761.4 530.9 Z",
      "position": {
        "x": 774.7,
        "y": 454.1
      },
      "badgeAnchor": {
        "x": 776.28,
        "y": 445.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "concordia-plateau",
      "name": "Concordia Plateau",
      "regionId": "wilkes",
      "adjacencies": [
        "aurora-caldera",
        "cape-ann",
        "vostok-hollow"
      ],
      "shape": "M 810.9 523.2 L 838.9 424.3 L 955.7 413.6 L 954 416.7 L 954.2 420.4 L 954 424.1 L 955.1 428.8 L 957.1 433.2 L 957.9 438.1 L 960.2 442.4 L 959 453.7 L 958.3 465 L 959.4 476.3 L 957.6 487.6 L 958.9 491.8 L 959.1 496.1 L 960 500.3 L 962 504.2 L 964 505.3 L 966.3 505.8 L 968.3 506.9 L 970 508.4 L 967.1 510.1 L 964.6 512.5 L 962 514.5 L 959.5 516.8 L 963.2 521.6 L 966.9 526.2 L 966 532.2 L 963.8 537.8 L 959.1 538.3 L 955.5 541.4 L 951.3 543.4 L 946.8 544.1 L 940.5 551.6 L 935.3 559.9 L 934.2 567.2 Z",
      "position": {
        "x": 895.3,
        "y": 486
      },
      "badgeAnchor": {
        "x": 892.94,
        "y": 483.2
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dome-c",
      "name": "Dome C",
      "regionId": "wilkes",
      "adjacencies": [
        "aurora-caldera",
        "beardmore-glacier",
        "cape-adare",
        "casey-station",
        "knox-coast",
        "vostok-hollow"
      ],
      "shape": "M 641.6 566.9 L 761.4 530.9 L 783.3 540 L 786 603.1 L 681.2 667.7 L 653.6 622.2 Z",
      "position": {
        "x": 715.4,
        "y": 592.5
      },
      "badgeAnchor": {
        "x": 698.01,
        "y": 600.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "knox-coast",
      "name": "Knox Coast",
      "regionId": "wilkes",
      "adjacencies": [
        "aurora-caldera",
        "beardmore-glacier",
        "dome-c",
        "roosevelt-isle"
      ],
      "shape": "M 681.2 667.7 L 786 603.1 L 885.3 671.6 L 884.1 679.6 L 882.3 694.3 L 877 708.1 L 871.2 710.8 L 865.1 709.3 L 859 709.4 L 853.2 711.2 L 851.6 713.8 L 850.4 716.6 L 849.4 719.5 L 847.6 722 L 849.3 726.2 L 851.4 730.2 L 853.3 734.4 L 853.1 739 L 845.5 746.8 L 840.6 756.5 L 833.9 765 L 825.7 772 L 806.5 779.8 L 787.8 788.9 L 768 795.2 L 749.2 804.2 L 747.1 801.1 L 744.7 798.2 L 737.5 797.6 L 730.3 798.7 L 728 798.5 L 682.1 685.9 Z",
      "position": {
        "x": 778.4,
        "y": 702.5
      },
      "badgeAnchor": {
        "x": 773.68,
        "y": 700.51
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "aurora-caldera",
      "name": "Aurora Caldera",
      "regionId": "wilkes",
      "adjacencies": [
        "concordia-plateau",
        "dome-c",
        "knox-coast",
        "vostok-hollow"
      ],
      "shape": "M 783.3 540 L 810.9 523.2 L 934.2 567.2 L 933.8 569.6 L 929.5 578.5 L 936.7 586.4 L 940 596.5 L 941.3 606.9 L 941.3 617.3 L 936.6 620.1 L 931.3 621.5 L 925.7 622.2 L 920.9 624.9 L 919.8 628.2 L 919.6 631.6 L 916.8 633.8 L 915.6 637.1 L 913.5 637.7 L 911.4 638.4 L 909.1 638.5 L 907.2 637.1 L 904.1 641.6 L 899.7 644.9 L 895.5 648.2 L 890.9 651.1 L 886.3 665.1 L 885.3 671.6 L 786 603.1 Z",
      "position": {
        "x": 858.6,
        "y": 591
      },
      "badgeAnchor": {
        "x": 869.71,
        "y": 600.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mcmurdo-sound",
      "name": "McMurdo Sound",
      "regionId": "ross",
      "adjacencies": [
        "executive-range",
        "ross-ice-shelf"
      ],
      "shape": "M 309.5 651.3 L 340.1 580.6 L 381.1 602.4 L 381.1 602.4 L 376.3 604 L 376.2 609.2 L 378 614.1 L 381.2 618 L 383.8 622.4 L 381.8 626.9 L 379.8 631.4 L 379.1 636.2 L 378.1 641 L 380.3 642.2 L 382.7 643.2 L 385.1 644.1 L 387.6 644.6 L 386.6 647.4 L 385.7 650.2 L 385.5 653.2 L 385.3 656.1 L 382.4 657.4 L 379.2 658.1 L 376.3 656.5 L 373.1 656.1 L 369.7 650.3 L 366.2 644.7 L 361.6 639.8 L 356.9 635.1 L 352.7 635.3 L 348.7 634.1 L 344.5 634.3 L 340.4 633.4 L 335.4 638.8 L 329.4 642.9 L 325.1 648.9 L 321.8 655.4 Z",
      "position": {
        "x": 353.95,
        "y": 611.98
      },
      "badgeAnchor": {
        "x": 353.95,
        "y": 611.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ross-ice-shelf",
      "name": "Ross Ice Shelf",
      "regionId": "ross",
      "adjacencies": [
        "executive-range",
        "mcmurdo-sound",
        "mount-erebus",
        "pine-island",
        "vinson-massif"
      ],
      "shape": "M 337.6 559.5 L 375.9 491.9 L 453.8 504.7 L 454.8 512.2 L 454.2 511.8 L 444.1 508 L 441.4 508.4 L 438.7 508.7 L 436 508.3 L 433.3 508 L 431.6 511 L 430.8 514.4 L 434.2 519.3 L 439 523 L 443.9 526.1 L 449.1 529 L 446.5 531.6 L 444.4 534.6 L 446.2 537.2 L 447.9 539.9 L 448.7 543 L 449.2 546.1 L 445.2 545.5 L 441.1 545.6 L 437.2 546.9 L 433.4 548.3 L 434.4 551.6 L 433.1 554.8 L 433.2 558 L 433.4 561.2 L 430.9 559.9 L 428.7 558 L 427.1 555.7 L 425.6 553.3 L 422.9 554.2 L 420.3 552.9 L 417.7 553.3 L 415.3 554.5 L 414.7 559.5 L 411.3 563.3 L 409.4 567.8 L 406.4 571.6 L 407.4 575.2 L 408.6 578.8 L 408.6 582.5 L 408.7 586.3 L 405.5 584.1 L 401.9 583.1 L 398.1 583.3 L 394.3 583 L 394 585.6 L 393.9 588.2 L 393 590.7 L 393.1 593.4 L 389.8 597.3 L 385.7 600.4 L 381.1 602.4 L 340.1 580.6 Z",
      "position": {
        "x": 390.2,
        "y": 543.4
      },
      "badgeAnchor": {
        "x": 379.72,
        "y": 552.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mount-erebus",
      "name": "Mount Erebus",
      "regionId": "ross",
      "adjacencies": [
        "argus-dome",
        "cape-adare",
        "casey-station",
        "ross-ice-shelf",
        "vinson-massif"
      ],
      "shape": "M 453.8 504.7 L 490.1 483.4 L 608.1 518.8 L 610.9 528.1 L 539.2 592.6 L 530.3 588 L 522.6 574.5 L 516.2 560.5 L 504.5 550.7 L 495.7 549.4 L 489.5 543 L 481.7 539.9 L 474.4 535.7 L 465.5 528.4 L 463.6 517.1 L 454.8 512.2 Z",
      "position": {
        "x": 531.2,
        "y": 530.6
      },
      "badgeAnchor": {
        "x": 544.62,
        "y": 539.71
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cape-adare",
      "name": "Cape Adare",
      "regionId": "ross",
      "adjacencies": [
        "beardmore-glacier",
        "casey-station",
        "dome-c",
        "mount-erebus"
      ],
      "shape": "M 539.2 592.6 L 610.9 528.1 L 641.6 566.9 L 653.6 622.2 L 544 653.3 L 543.7 652.3 L 547.7 647.9 L 552.9 645.2 L 555.5 640 L 557.7 634.6 L 557.7 630.7 L 557.9 626.7 L 556.8 623 L 555.1 619.4 L 554 612.7 L 551.8 606.3 L 546.9 601.5 L 544.2 595.1 Z",
      "position": {
        "x": 598.7,
        "y": 594.4
      },
      "badgeAnchor": {
        "x": 601.76,
        "y": 592.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beardmore-glacier",
      "name": "Beardmore Glacier",
      "regionId": "ross",
      "adjacencies": [
        "cape-adare",
        "dome-c",
        "knox-coast",
        "roosevelt-isle"
      ],
      "shape": "M 544 653.3 L 653.6 622.2 L 681.2 667.7 L 682.1 685.9 L 572.9 707.9 L 571.9 706.2 L 566.6 697.4 L 561.9 687.8 L 563.4 677.2 L 557.1 672 L 550.5 667.2 L 546.1 660.2 Z",
      "position": {
        "x": 616.4,
        "y": 666.5
      },
      "badgeAnchor": {
        "x": 636.79,
        "y": 661.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "roosevelt-isle",
      "name": "Roosevelt Isle",
      "regionId": "ross",
      "adjacencies": [
        "beardmore-glacier",
        "knox-coast"
      ],
      "shape": "M 544.6 783 L 545.6 778 L 548.5 773 L 546 767.8 L 548.7 766.4 L 550.7 764.1 L 552.9 762.1 L 555.5 760.6 L 559.8 752 L 564.4 743.5 L 565.1 733.8 L 568.1 724.6 L 569.8 721.7 L 572 719.3 L 574.4 716.9 L 577.1 715 L 572.9 707.9 L 682.1 685.9 L 728 798.5 L 723.1 798.2 L 716.1 796.4 L 711.6 797.5 L 708.1 800.6 L 703.7 801.8 L 700 804.6 L 697.7 803.5 L 695.6 802.2 L 693.5 800.8 L 691.2 799.9 L 686.1 801.7 L 682.3 805.5 L 677.6 808 L 674.2 812.2 L 671.1 811.8 L 668.2 810.8 L 665.5 809.4 L 662.7 808 L 657.5 810.8 L 651.6 811 L 646 812.4 L 640.4 813.7 L 634.3 808.5 L 629.9 801.8 L 621.9 802.3 L 614 801.5 L 602.5 799.7 L 591.1 802.2 L 579.6 799.7 L 568.2 802.4 L 562.4 798.4 L 555.5 797 L 550.1 792.7 L 545 788.1 Z",
      "position": {
        "x": 636.1,
        "y": 754.6
      },
      "badgeAnchor": {
        "x": 650.63,
        "y": 751.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thwaites-glacier",
      "name": "Thwaites Glacier",
      "regionId": "marie-byrd",
      "adjacencies": [
        "amundsen-coast",
        "marguerite-bay",
        "pine-island",
        "sidley-crest"
      ],
      "shape": "M 139.1 423 L 147 412.9 L 147.9 411.1 L 268.2 417.4 L 243.4 513.3 L 200.6 525.8 L 200.9 522.4 L 200.3 518.2 L 200.7 514.1 L 197.7 508.5 L 196.6 502.3 L 192.3 497.8 L 189.2 492.3 L 189.6 489 L 189.6 485.7 L 191.3 482.9 L 191.6 479.5 L 189.4 480.5 L 187.1 481.4 L 185.1 482.7 L 183.3 484.3 L 181.2 481.6 L 178.6 479.5 L 175.5 478.1 L 172.1 477.6 L 170.3 482.3 L 167.7 486.6 L 165.9 491.2 L 164.3 495.9 L 163.6 492.5 L 162.4 489.2 L 161.1 485.9 L 159.5 482.8 L 156.9 482 L 154.3 482.8 L 155.4 487.8 L 155.3 492.9 L 153.9 497.8 L 152.9 502.8 L 150.7 505.8 L 147.3 507.5 L 147.6 487.9 L 150.6 468.6 L 149.9 449 L 145.3 429.9 L 143.8 428.1 L 142.2 426.5 L 140.2 425.1 Z",
      "position": {
        "x": 205.2,
        "y": 458.2
      },
      "badgeAnchor": {
        "x": 214.46,
        "y": 454.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pine-island",
      "name": "Pine Island",
      "regionId": "marie-byrd",
      "adjacencies": [
        "amundsen-coast",
        "executive-range",
        "marguerite-bay",
        "ross-ice-shelf",
        "thwaites-glacier",
        "vinson-massif"
      ],
      "shape": "M 243.4 513.3 L 268.2 417.4 L 319.3 396.4 L 375.9 491.9 L 337.6 559.5 L 271.3 550.1 Z",
      "position": {
        "x": 306.9,
        "y": 484.5
      },
      "badgeAnchor": {
        "x": 307.58,
        "y": 495.79
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "amundsen-coast",
      "name": "Amundsen Coast",
      "regionId": "marie-byrd",
      "adjacencies": [
        "executive-range",
        "pine-island",
        "sidley-crest",
        "thwaites-glacier"
      ],
      "shape": "M 185.2 538.2 L 185.9 535 L 186.4 531.7 L 190.6 531.9 L 193.8 534.6 L 197.5 533.1 L 200.7 530.6 L 200.5 526.5 L 200.6 525.8 L 243.4 513.3 L 271.3 550.1 L 256.2 566.9 L 202.4 569 L 202.1 566.3 L 199.2 563.2 L 197.4 559.5 L 197.7 555.3 L 195.7 554.5 L 193.6 554 L 191.5 553.7 L 189.4 553.7 L 191.8 551.8 L 193.7 549.3 L 194.8 546.4 L 197.2 544.4 L 196 541 L 195.8 537.4 L 193.2 538.2 L 190.5 538.4 L 187.9 538 Z",
      "position": {
        "x": 229.4,
        "y": 544.3
      },
      "badgeAnchor": {
        "x": 232.29,
        "y": 542.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sidley-crest",
      "name": "Sidley Crest",
      "regionId": "marie-byrd",
      "adjacencies": [
        "amundsen-coast",
        "executive-range",
        "thwaites-glacier"
      ],
      "shape": "M 202.4 569 L 256.2 566.9 L 244.6 616.3 L 229.3 606.1 L 213.2 590.4 L 202.6 570.5 Z",
      "position": {
        "x": 232.3,
        "y": 585.5
      },
      "badgeAnchor": {
        "x": 233.38,
        "y": 584.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "executive-range",
      "name": "Executive Range",
      "regionId": "marie-byrd",
      "adjacencies": [
        "amundsen-coast",
        "mcmurdo-sound",
        "pine-island",
        "ross-ice-shelf",
        "sidley-crest"
      ],
      "shape": "M 244.6 616.3 L 256.2 566.9 L 271.3 550.1 L 337.6 559.5 L 340.1 580.6 L 309.5 651.3 L 307.1 650.5 L 291.5 651.2 L 277.1 645.7 L 261.7 644.6 L 261.6 642.6 L 262.1 640.6 L 262.1 638.6 L 261.7 636.6 L 248.1 618.6 Z",
      "position": {
        "x": 291.6,
        "y": 598.3
      },
      "badgeAnchor": {
        "x": 290.86,
        "y": 592.79
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "amundsen-scott",
      "name": "Amundsen-Scott",
      "regionId": "polar-plateau",
      "adjacencies": [
        "argus-dome",
        "muhlig-hofmann",
        "palmer-spire",
        "pole-of-inaccessibility",
        "vinson-massif"
      ],
      "shape": "M 357.5 338.6 L 430.7 266 L 510.1 283.1 L 518 384.4 L 497 407.5 L 358.7 342.3 Z",
      "position": {
        "x": 453,
        "y": 332.8
      },
      "badgeAnchor": {
        "x": 450.29,
        "y": 325.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pole-of-inaccessibility",
      "name": "Pole of Inaccessibility",
      "regionId": "polar-plateau",
      "adjacencies": [
        "amery-shelf",
        "amundsen-scott",
        "argus-dome",
        "muhlig-hofmann",
        "riiser-larsen"
      ],
      "shape": "M 510.1 283.1 L 583.9 248.7 L 635.7 257.1 L 666.2 395 L 518 384.4 Z",
      "position": {
        "x": 585.6,
        "y": 326.3
      },
      "badgeAnchor": {
        "x": 580.83,
        "y": 324.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vinson-massif",
      "name": "Vinson Massif",
      "regionId": "polar-plateau",
      "adjacencies": [
        "amundsen-scott",
        "argus-dome",
        "marguerite-bay",
        "mount-erebus",
        "pine-island",
        "ross-ice-shelf"
      ],
      "shape": "M 319.3 396.4 L 323.8 384.4 L 325.3 384.7 L 327.5 382.6 L 329.5 380.4 L 325.9 378.6 L 332.3 361.4 L 338.4 364.8 L 349.9 365.7 L 361.2 367.4 L 372.5 365.6 L 368 356.1 L 360.7 348.4 L 358.7 342.3 L 497 407.5 L 490.1 483.4 L 453.8 504.7 L 375.9 491.9 Z",
      "position": {
        "x": 411.8,
        "y": 429.6
      },
      "badgeAnchor": {
        "x": 416.48,
        "y": 436.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "argus-dome",
      "name": "Argus Dome",
      "regionId": "polar-plateau",
      "adjacencies": [
        "amery-shelf",
        "amundsen-scott",
        "casey-station",
        "mount-erebus",
        "pole-of-inaccessibility",
        "vinson-massif"
      ],
      "shape": "M 490.1 483.4 L 497 407.5 L 518 384.4 L 666.2 395 L 667.3 396.5 L 608.1 518.8 Z",
      "position": {
        "x": 571.3,
        "y": 443.6
      },
      "badgeAnchor": {
        "x": 564.86,
        "y": 445.3
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-4d94a473-b47bbc15",
  "seaRoutes": []
}
